// removed by extract-text-webpack-plugin
module.exports = {"icon":"Icon__icon___2HswS","isInline":"Icon__isInline___VPseI","iconText":"Icon__iconText___2L7iT","isHiddenDesktop":"Icon__isHiddenDesktop___2ZdVR","isHiddenMobile":"Icon__isHiddenMobile___1-x06"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/Icon.scss
// module id = 551
// module chunks = 0